export default {
  // Page title
  pageTitle: 'AI Customer Acquisition',

  // Top banner
  banner: {
    feature1: 'Global Regional Data Coverage',
    feature2: 'Aggregated Platform and Database Resources',
    feature3: 'Deep Contact Information Mining',
    feature4: 'Massive Data Precise Matching',
    totalData: 'Total Global Enterprise Data'
  },

  // Search area
  search: {
    byKeyword: 'By Keyword',
    byCompany: 'By Company',
    byDomain: 'By Domain',
    uploadCustomer: 'Upload My Customers',
    placeholder: 'Enter product or service keywords to search',
    searchButton: 'Search'
  },

  // AI expand search words
  aiExpand: {
    title: 'AI Extended Search Terms',
    expandCollapse: {
      expand: 'Expand',
      collapse: 'Collapse'
    },
    description: 'Based on the main search term, AI extends for you in',
    selectedCount: 'Extended the following related words, {count} terms selected',
    expandWords: 'Extended Terms',
    languages: {
      english: 'English',
      french: 'French',
      vietnamese: 'Vietnamese',
      japanese: 'Japanese'
    }
  },

  // Filter conditions
  filter: {
    title: 'Filter Conditions',
    countryRegion: 'Country/Region',
    selectCountry: 'Please select country or region',
    hasEmail: 'Has Email',
    nonLogistics: 'Non-Logistics Company',
    hasCustoms: 'Has Customs Data',
    hasWebsite: 'Has Website',
    applyFilter: 'Apply Filter',
    countries: {
      china: 'China',
      usa: 'United States',
      pakistan: 'Pakistan',
      venezuela: 'Venezuela',
      korea: 'Korea',
      panama: 'Panama',
      canada: 'Canada',
      georgia: 'Georgia',
      mexico: 'Mexico',
      jamaica: 'Jamaica',
      ukraine: 'Ukraine'
    }
  },

  // Search results
  results: {
    found: 'Found',
    resultsCount: 'results for you',
    selectAll: 'Select All',
    oneClickMarketing: 'One-Click Marketing',
    comprehensiveSort: 'Comprehensive Sort',
    enterpriseEmail: 'Enterprise Email',
    localName: 'Local Name',
    establishmentDate: 'Establishment Date',
    mainProducts: 'Main Products',
    industry: 'Industry',
    businessNature: 'Business Nature',
    mainMarket: 'Main Market',
    salesPlatform: 'Sales Platform',
    companyProfile: 'Company Profile',
    businessStatus: 'Business Status',
    companyType: 'Company Type',
    annualRevenue: 'Annual Revenue',
    aiCopy: 'AI Marketing',
    deepContact: 'Deep Contact Mining',
    noData: 'No search results found, please try other keywords'
  },

  // Upload modal
  upload: {
    title: 'Upload My Customers',
    fileTypeError: 'Unsupported file type, only .xls and .xlsx formats are supported',
    tips: 'Please upload files according to template format, only .xls and .xlsx formats are supported',
    uploadArea: {
      title: 'Click or drag files to this area to upload',
      supportedFormats: 'Only .xls and .xlsx formats are supported',
      uploadButton: 'Click to Upload'
    },
    buttons: {
      downloadTemplate: 'Download Template',
      cancel: 'Cancel',
      confirmUpload: 'Confirm Upload'
    },
    messages: {
      selectFile: 'Please select a file first',
      maxFilesExceeded: 'Maximum {max} files can be uploaded',
      fileSizeExceeded: 'File {files} size exceeds 10MB',
      uploadSuccess: 'Successfully uploaded {count} file(s)',
      allFailed: 'All files failed to upload, please try again',
      partialFailed: 'Some files failed to upload: {files}',
      uploadFailed: 'Upload failed, please try again',
      downloadTemplateSuccess: 'Template downloaded successfully',
      downloadTemplateFailed: 'Failed to download template, please try again'
    }
  },

  // AI copy generation
  aiCopy: {
    title: 'AI Marketing Copy Generation',
    recipients: 'Recipients',
    recipientDetails: 'Recipient Details',
    outputLength: 'Output Length',
    outputTone: 'Output Tone',
    outputLanguage: 'Output Language',
    emailType: 'Email Type',
    lengths: {
      auto: 'Auto',
      short: 'Short',
      medium: 'Medium',
      long: 'Long'
    },
    tones: {
      auto: 'Auto',
      friendly: 'Friendly',
      formal: 'Formal',
      amiable: 'Amiable',
      professional: 'Professional',
      funny: 'Funny'
    },
    languages: {
      chinese: 'Chinese',
      english: 'English'
    },
    contentTypes: {
      ratePromotion: 'Rate Promotion',
      developmentLetter: 'Development Letter'
    },
    rateSelection: {
      pol: 'Port of Loading',
      pod: 'Port of Discharge',
      carrier: 'Carrier',
      selectPol: 'Please select port of loading',
      selectPod: 'Please select port of discharge',
      selectCarrier: 'Please select carrier',
      query: 'Query',
      selectRates: 'Select Rates',
      shipCompany: 'Carrier',
      etd: 'ETD',
      voyageDays: 'Transit Days',
      vessel: 'Vessel',
      voyage: 'Voyage',
      validPeriod: 'Valid Period',
      loading: 'Loading...',
      noData: 'No rate information, please query first',
      allLoaded: 'All data loaded',
      loadedCount: 'Loaded {count} rate records'
    },
    buttons: {
      copy: 'One-Click Copy',
      generate: 'Start Generate',
      confirmAndSend: 'Confirm and Send',
      close: 'Close',
      viewEmails: 'View Emails'
    },
    generatedTitle: 'Subject',
    generatedContent: 'Generated Marketing Copy',
    messages: {
      selectRate: 'Please select rate information first',
      dataLoading: 'Base data is loading, please wait',
      generateSuccess: 'Content generated successfully',
      generateFailed: 'Generation failed, please try again',
      generateEmpty: 'Generated content is empty',
      copySuccess: 'Copied successfully',
      copyFailed: 'Copy failed, please try again',
      queryFailed: 'Rate query failed, please try again',
      sendSuccess: 'Email sent successfully!',
      sendFailed: 'Failed to send email, please try again',
      sending: 'Sending email...',
      noRecipients: 'Please add recipients first',
      noTitle: 'Please enter email subject',
      noContent: 'Please generate email content first'
    },
    sendSuccess: {
      title: 'Email sent successfully!',
      description: 'Your marketing email has been successfully sent to all recipients',
      subject: 'Subject',
      recipientCount: 'Recipient Count',
      recipients: 'recipients',
      emailType: 'Email Type',
      marketingEmail: 'Rate Promotion Email',
      sendTime: 'Send Time',
      emailInfo: 'Email Information',
      more: 'more',
      defaultSubject: 'AI Marketing Email'
    },
    recipientModal: {
      searchPlaceholder: 'Search recipient email',
      addEmailPlaceholder: 'Enter email address',
      addButton: 'Add',
      deleteButton: 'Delete',
      closeButton: 'Close',
      noRecipients: 'No recipients',
      manualAdd: 'Manually Added',
      customerInfo: 'Customer: {customerName} | Contact: {contactName}',
      customerLabel: 'Customer',
      contactLabel: 'Contact',
      emailFormatError: 'Invalid email format',
      emailExists: 'Email already exists',
      addSuccess: 'Added successfully',
      deleteSuccess: 'Deleted successfully',
      editSuccess: 'Updated successfully',
      moreRecipients: '+{count} more',
      establishmentDate: 'Establishment Date',
      employeeCount: 'Employee Count',
      contactPhone: 'Contact Phone'
    }
  },

  // Contact information
  contact: {
    title: 'Contact Information',
    company: 'Company',
    position: 'Position',
    department: 'Department',
    email: 'Contact Email',
    phone: 'Contact Phone',
    noContacts: 'No contact information available',
    closeButton: 'Close'
  },

  // Common messages
  messages: {
    searchEmpty: 'Please enter search content',
    searchSuccess: 'Found {count} results for you',
    searchFailed: 'Search failed, please try again'
  },

  // Units
  units: {
    days: 'days',
    tenThousandYuan: ' (×10K CNY)',
    count: '',
    person: ''
  }
}
